/**============================================================
*   [HeaderNavigation]
*   description : グローバルナビの処理を記述
============================================================*/
import {createApp, onMounted, reactive, watchEffect} from 'vue';
import { createMedia } from 'vue-use-media';
import NavSlider from './navSlider';

document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('header-navigation')){
    const HeaderNavigation = createApp({
      setup() {
        const media = createMedia({
          isDesktop: 'screen and (min-width: 769px)'
        })
        const state = reactive({
          isScrolled: false,
          isGnavOpened: false,
          categoryNum: 0,
          isStopAnimation: false,
        })

        const resetGnav = function() {
          //アニメーションを切る（切り替え時・ブラウザバック時の対策）
          state.isStopAnimation = true;

          state.categoryNum = 0;
          if(media.isDesktop){
            //PC時のデフォルト状態
            state.isGnavOpened = true;
          }else{
            //SP時のデフォルト状態
            state.isGnavOpened = false;
          }

          let categoryTimer;
          clearTimeout(categoryTimer);
          categoryTimer = setTimeout(() => {
            state.categoryNum = 0;
          }, 100);
        }

        const headerScroll = function() {
          let winTop =  window.pageYOffset || document.documentElement.scrollTop;
          if(winTop > 25){
            state.isScrolled = true;
          }else{
            state.isScrolled = false;
          }
        }

        onMounted(() => {

          //初期化
          watchEffect(() => {
            resetGnav();
          })

          //スクロール時に背景つける
          headerScroll();
          window.addEventListener('scroll', headerScroll);

          //キャッシュによる表示のリセット対策
          window.addEventListener('onbeforeunload', () => {}, false);
          window.addEventListener('onunload', () => {}, false);
          window.addEventListener('pageshow', function(event) {
            if (event.persisted) {
              resetGnav();
            }
          });

          //スライダー
          createSlider();
        })

        //子階層の開閉
        //指定のカテゴリ名を受け取って表示：初期値は0（非表示）
        const toggleCategory = (num)=> {
          let currentNum = state.categoryNum;

          if(currentNum === num || num === 0){
            state.categoryNum = 0;
            if (!media.isDesktop) {
              document.getElementsByTagName('html')[0].classList.remove('is-gnav-opened');
            }
          }else{
            state.categoryNum = num;
            if (!media.isDesktop) {
              document.getElementsByTagName('html')[0].classList.add('is-gnav-opened');
            }
          }
        }

        //[SP用]グロナビの開閉（トグル）
        const toggleGnav = function() {
          state.isStopAnimation = false;

          if(state.isGnavOpened){
            state.isGnavOpened = false;
            document.getElementsByTagName('html')[0].classList.remove('is-gnav-opened');
          }else{
            state.isGnavOpened = true;
            document.getElementsByTagName('html')[0].classList.add('is-gnav-opened');
          }
        }

        //[SP用]グロナビ閉じるのみ
        const closeGnav = function() {
          state.isGnavOpened = false;
        }


        /* スライド設定 */
        const createSlider = ()=> {
          const NavSliderElem = document.getElementsByClassName('l-gnav__list__child__banners');

          if (!NavSliderElem.length) return;
          for (let i = 0; i < NavSliderElem.length; i++) {
            new NavSlider(NavSliderElem[i], i);
          }
        }

        return {
          media,
          state,
          toggleCategory,
          toggleGnav,
          closeGnav,
          resetGnav,
          headerScroll
        }
      },
    })
    HeaderNavigation.mount('#header-navigation')
  }
})
